module.exports = (isCurrentlyMobileView, setForceMobileView, setAllPageRawContent, shouldBeMobileView) => {
    if (isCurrentlyMobileView !== shouldBeMobileView) {
        setForceMobileView(shouldBeMobileView)
        setAllPageRawContent({})
    }
}
